import { ListItem as MUIListItem, ListItemProps as MUIListItemProps } from '@mui/material';

export interface ListItemProps extends MUIListItemProps {}

export const ListItem = MUIListItem;
